import React from 'react';
import AcceptWorkspaceInvite from '../components/atoms/AcceptWorkspaceInvite';

const AcceptWorkspaceInvitePage = () => {
  return <AcceptWorkspaceInvite />;
};

export default AcceptWorkspaceInvitePage;
